import { Col, Row } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'


import './index.scss'
import { facebookIcon, instagramIcon, logoFooter, youtubeIcon } from '../../assets'
import useGetLang from '../../hooks/useGetLang'
import { URL_SOCIAL_FACEBOOK, URL_SOCIAL_INSTAGRAM, URL_SOCIAL_YOUTUBE } from '../../constant'

const Footer = () => {
    return (
        <div className="footer">
            {/* <Row className="footer__wrapper"> */}
            {/* <Col span={24} className='text-center footer__center-respon footer__logo--wrapper'>
                    <img className="footer__logo" src={logoFooter} alt="" />
                </Col> */}
            {/* <Col lg={16} md={18} xs={24} className="footer__info">
                    <div className="">
                        {useGetLang('company_statement')}
                    </div>
                    <div className="">
                        <strong>{useGetLang('company_name')}</strong>
                        <span>
                            {useGetLang('business_registration')}
                        </span>
                        <span>
                            {useGetLang('address_footer')}
                        </span>
                        <span>{useGetLang('phone_number_footer')}</span>
                        <span>Email: sandals.digital@gmail.com</span>
                    </div>
                </Col> */}
            {/* </Row> */}
            <Row className="footer__copyright">
                <Col span={24}>
                    <div className="footer__content">
                        <span>{useGetLang('copyrightOwnedBy')} © 2024 Erateq  </span>
                        <div className="footer__social">
                            <Link
                                target='_blank'
                                to={URL_SOCIAL_FACEBOOK}
                                className="footer__social--item">
                                <img src={facebookIcon} alt="" />
                            </Link>
                            <Link
                                target='_blank'
                                to={URL_SOCIAL_INSTAGRAM}
                                className="footer__social--item">
                                <img src={instagramIcon} alt="" />
                            </Link>
                            <Link
                                target='_blank'
                                to={URL_SOCIAL_YOUTUBE}
                                className="footer__social--item">
                                <img src={youtubeIcon} alt="" />
                            </Link>

                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default Footer